import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';

const Internship = (props) => {
    const { companyName, role, duration, introText, keyPointOne, keyPointTwo, keyPointThree, keyPointFour, offsetValue } = props.details;

    return (
        <>
            <div className="internships__box">
                <h2>
                    <p>{companyName}</p>
                    <p>{role}</p>
                </h2>
                <h3>
                    <FontAwesomeIcon icon={faCalendarDays} className="internships__calendar" />&nbsp;&nbsp;
                    {duration}
                </h3>
                <ul>
                    <p>{introText}</p>
                    <li data-aos='fade-right' data-aos-delay='200' data-aos-offset={offsetValue}>
                        <span>{keyPointOne}</span>
                    </li>
                    <li data-aos='fade-right' data-aos-delay='400' data-aos-offset={offsetValue}>
                        <span>{keyPointTwo}</span>
                    </li>
                    <li data-aos='fade-right' data-aos-delay='600' data-aos-offset={offsetValue}>
                        <span>{keyPointThree}</span>
                    </li>
                    {/* ✅ Optional rendering for 4th point */}
                    {keyPointFour && (
                        <li data-aos='fade-right' data-aos-delay='800' data-aos-offset={offsetValue}>
                            <span>{keyPointFour}</span>
                        </li>
                    )}
                </ul>
            </div>
        </>
    );
}

export default Internship;
